export const uploadTypes = {
  attachment: 'ASSIGNMENT_ATTACHMENT',
  submission: 'ASSIGNMENT_SUBMISSION',
};

export const FILE_REDUCER_ACTIONS = {
  selectFile: 'SELECT_FILE',
  startUploadFile: 'START_UPLOAD_FILE',
  uploadProgress: 'UPLOAD_PROGRESS',
  fileUploadComplete: 'FILE_UPLOAD_COMPLETE',
  errorFileUpload: 'ERROR_FILE_UPLOAD',
  resetFileUpload: 'RESET_FILE_UPLOAD',
  updateTaskStatus: 'UPDATE_TASK_STATUS',
};

export const errorTypes = {
  uploadConnectionError: 'UploadConnectionError',
  fileFormatError: 'FileFormatError',
  fileSizeError: 'FileSizeError',
  conversionError: 'ConversionError',
  videoFileDurationLimit: 'VideoFileDurationLimit',
  teacherResponseAttachmentError: 'TeacherResponseAttachmentError',
};

export const TASK_STATUS = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
};
